export default "__VITE_ASSET__ePnBg7RQ__"